'use client';

import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import { AllocationIcon } from '../assets';

export const ViewAllocationSection = ({ currency }: { currency: string }) => {
  return (
    <div
      className={center({
        p: 8,
        gap: 8,
        bg: 'background.default.level-0',
      })}
    >
      <AllocationIcon />
      <div className={css({ textStyle: 'Text/M/Regular' })}>
        <IsomorphicLink
          href={`/earn/allocations?currency=${currency}`}
          className={css({ textStyle: 'Text/M/Underline', color: 'content.default.level-3' })}
        >
          <span>View your allocations</span>
        </IsomorphicLink>
        <span className={css({ color: 'content.default.level-3' })}> and see how you can get maximum earnings</span>
      </div>
    </div>
  );
};
